import {Routes} from '@angular/router';
import { Authority } from '../constants/authority.constants';

export const CommonLayout_ROUTES: Routes = [

  // Dashboard
  {
    path: 'dashboard',
    data: { title: 'Dashboard' , header: 'Dashboard' , authorities: [Authority.ADMIN]},
    loadChildren: () => import('../../modules/dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'transactions',
    data: { title: 'TranGiao dịchsactions', header: 'Giao dịch'},
    loadChildren: () => import('../../modules/transaction/transaction.module').then(m => m.TransactionModule),
  },
  {
    path: 'products',
    data: { title: 'Products', header: 'Sản phẩm'},
    loadChildren: () => import('../../modules/product/product.module').then(m => m.ProductModule),
  },
  {
    path: 'accounts',
    data: { title: 'Tài khoản', header: 'Tài khoản'},
    loadChildren: () => import('../../modules/account/account.module').then(m => m.AccountModule),
  },
  {
    path: 'users',
    data: { title: 'Người dùng', header: 'Người dùng'},
    loadChildren: () => import('../../modules/users/users.module').then(m => m.UsersModule)
  },
  {
    path: 'cms',
    data: { title: 'CMS', header: 'CMS' , authorities: [Authority.ADMIN]},
    loadChildren: () => import('../../modules/cms/cms.module').then(m => m.CMSModule)
  },
  {
    path: 'master-data',
    data: { title: 'Dữ liệu', header: 'Dữ liệu' , authorities: [Authority.ADMIN]},
    loadChildren: () => import('../../modules/master-data/master-data.module').then(m => m.MasterDataModule)
  },
  {
    path: 'partner',
    data: { title: 'Partner', header: 'Đối tác'},
    loadChildren: () => import('../../modules/partner/partner.module').then(m => m.PartnerModule),
  },
  {
    path: 'mail',
    data: { title: 'Mail' , header: 'Mail' , authorities: [Authority.ADMIN]},
    loadChildren: () => import('../../modules/mail/mail.module').then(m => m.MailModule)
  },
  {
    path: 'settings',
    data: { title: 'Settings' , header: 'Hệ thống', authorities: [Authority.ADMIN]},
    loadChildren: () => import('../../modules/settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: 'marketing',
    data: { title: 'Marketing' , header: 'Marketing' , authorities: [Authority.ADMIN]},
    loadChildren: () => import('../../modules/marketing/marketing.module').then(m => m.MakertingModule)
  },
  {
    path: 'fee',
    data: { title: 'Tính phí' , header: 'Tính phí' , authorities: [Authority.ADMIN]},
    loadChildren: () => import('../../modules/fee/fee.module').then(m => m.FeeModule)
  },
  {
    path: 'developer',
    data: { title: 'Developer' , header: 'Developer', authorities: [Authority.DEVELOPER]},
    loadChildren: () => import('../../modules/developer/developer.module').then(m => m.DeveloperModule)
  },
  // Pages
  {
    path: 'pages',
    data: {
      title: 'Pages '
    },
    children: [
      {
        path: '',
        redirectTo: '/transaction',
        pathMatch: 'full'
      },
      {
        path: '',
        loadChildren: () => import('../../pages/pages.module').then(m => m.PagesModule)
      },
    ]
  },
];
